<template>
  <div class="bg">
    <vue-particles
      class="bg_line"
      color="#dedede"
      :particleOpacity="0.7"
      :particlesNumber="75"
      shapeType="circle"
      :particleSize="4"
      linesColor="#dedede"
      :linesWidth="1"
      :lineLinked="true"
      :lineOpacity="0.5"
      :linesDistance="200"
      hoverMode="grab"
      :moveSpeed="3"
      :hoverEffect="true"
      :clickEffect="true"
      clickMode="push"
    >
    </vue-particles>
    <div class="login_box">
      <div class="login">
        <div class="login_left">
          <img v-if="sysInfo.logo_white" :src="sysInfo.logo_white" class="logo" alt="" />
          <Img v-else class="logo" src="/logo.png" alt="" />
          <dl>
            <dt>联系我们</dt>
            <dd>
              <Img src="/home/qrcode.jpg" />
            </dd>
          </dl>
        </div>
        <Card class="login-card" v-if="login_type === 1">
          <p slot="title" v-if="type === 1">
            {{ loginFormData.kind === 1 ? '学生登录' : '教师登录' }}
          </p>
          <p slot="title" v-if="type != 1">
            {{ type === 1 ? '登录' : type === 2 ? '注册' : '找回密码' }}
          </p>
          <br />
          <Form ref="loginFormData" class="card_form" :model="loginFormData" :rules="loginRules" :label-width="66" v-show="type === 1" label-position="left">
            <FormItem prop="phone">
              <span slot="label">手机号</span>
              <Input
                type="text"
                :maxlength="11"
                v-model.trim="loginFormData.phone"
                placeholder="请输入手机号"
                @keyup.enter.native="handleSubmit('loginFormData')"
              />
            </FormItem>
            <FormItem prop="password">
              <span slot="label">密码</span>
              <Input type="password" v-model.trim="loginFormData.password" @keyup.enter.native="handleSubmit('loginFormData')" placeholder="请输入密码" />
              <span class="forgetpwd primary" @click="loginFormData.kind === 1 ? (loginFormData.kind = 2) : (loginFormData.kind = 1)">{{
                loginFormData.kind === 1 ? '教师登录' : '学生登录'
              }}</span>
            </FormItem>
          </Form>
          <Form ref="regFormData" class="card_form" :model="regFormData" :rules="regRules" :label-width="70" v-show="type !== 1" label-position="left">
            <FormItem prop="phone">
              <span slot="label">手机号</span>
              <Input
                type="text"
                :maxlength="11"
                v-model.trim="regFormData.phone"
                placeholder="请输入手机号"
                @keyup.enter.native="handleSubmit('regFormData')"
              />
            </FormItem>
            <FormItem prop="authCode">
              <span slot="label">验证码</span>
              <Input v-model.trim="regFormData.authCode" placeholder="请输入验证码" @keyup.enter.native="handleSubmit('regFormData')">
                <Button class="get_btn" type="primary" :disabled="codeStatus" @click="getCode" slot="append">{{
                  codeStatus ? `${this.timeCount}s` : '获取'
                }}</Button>
              </Input>
            </FormItem>
            <FormItem prop="password">
              <span slot="label">密码</span>
              <Input type="password" v-model.trim="regFormData.password" placeholder="请输入密码" @keyup.enter.native="handleSubmit('regFormData')" />
            </FormItem>
          </Form>
          <div class="btngroup" v-if="type === 1">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('loginFormData')">登录</Button>
            <div class="register">
              <Button @click="type = 2">免费注册</Button>
              <p @click="type = 3">忘记密码</p>
            </div>
          </div>
          <div class="btngroup" v-if="type === 2">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('regFormData')">注册</Button>
            <div class="register">
              <p class="color_333 margin_auto">已有账号，去<span @click="type = 1">登录</span></p>
            </div>
          </div>
          <div class="btngroup" v-if="type === 3">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('regFormData')">设置密码</Button>
            <div class="register">
              <p class="color_333 margin_auto">已有账号，去<span @click="type = 1">登录</span></p>
            </div>
          </div>
        </Card>
        <!-- 账号密码登录 -->
        <Card class="login-card login_form2" v-else>
          <p slot="title" v-if="type === 1">
            {{ loginFormData2.kind === 1 ? '学生登录' : '教师登录' }}
          </p>
          <p slot="title" v-if="type != 1">
            {{ type === 1 ? '登录' : type === 2 && loginFormData2.kind === 1 ? '学生注册' : type === 2 && loginFormData2.kind === 2 ? '老师注册' : '找回密码' }}
          </p>
          <br />
          <Form ref="loginFormData2" class="card_form" :model="loginFormData2" :rules="loginRules2" :label-width="60" v-show="type === 1" label-position="left">
            <FormItem prop="account">
              <span slot="label">账号</span>
              <Input type="text" v-model.trim="loginFormData2.account" placeholder="请输入账号" @keyup.enter.native="handleSubmit('loginFormData2')" />
            </FormItem>
            <FormItem prop="password">
              <span slot="label">密码</span>
              <Input type="password" v-model.trim="loginFormData2.password" @keyup.enter.native="handleSubmit('loginFormData2')" placeholder="请输入密码" />
              <span class="forgetpwd primary" @click="loginFormData2.kind === 1 ? (loginFormData2.kind = 2) : (loginFormData2.kind = 1)">{{
                loginFormData2.kind === 1 ? '教师登录' : '学生登录'
              }}</span>
            </FormItem>
          </Form>
          <Form ref="regFormData2" class="card_form" :model="regFormData2" :rules="regRules2" :label-width="80" v-show="type !== 1" label-position="left">
            <FormItem prop="account">
              <span slot="label">账号</span>
              <Input type="text" v-model.trim="regFormData2.account" placeholder="请输入账号" @keyup.enter.native="handleSubmit('regFormData2')" />
            </FormItem>
            <FormItem prop="password">
              <span slot="label">密码</span>
              <Input type="password" v-model.trim="regFormData2.password" placeholder="请输入密码" @keyup.enter.native="handleSubmit('regFormData2')" />
            </FormItem>
            <FormItem prop="confirm_password">
              <span slot="label">确认密码</span>
              <Input type="password" v-model.trim="regFormData2.confirm_password" placeholder="请输入密码" @keyup.enter.native="handleSubmit('regFormData2')" />
            </FormItem>
            <FormItem prop="captcha">
              <span slot="label">验证码</span>
              <div class="flex">
                <Input v-model.trim="regFormData2.captcha" placeholder="请输入验证码" @keyup.enter.native="handleSubmit('regFormData2')" />
                <img :src="imgCode" class="img-code" @click="getImgCode()" />
              </div>
            </FormItem>
          </Form>
          <div class="btngroup" v-if="type === 1">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('loginFormData2')">登录</Button>
            <div class="register">
              <Button @click=";(type = 2), (regFormData2.kind = loginFormData2.kind), getImgCode()">免费注册</Button>
              <!-- <p @click="type = 3">忘记密码</p> -->
            </div>
          </div>
          <div class="btngroup" v-if="type === 2">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('regFormData2')">注册</Button>
            <div class="register">
              <p class="color_333 margin_auto">已有账号，去<span @click="type = 1">登录</span></p>
            </div>
          </div>
          <div class="btngroup" v-if="type === 3">
            <Button class="login_btn" type="primary" :loading="handleBtnLoading" long @click="handleSubmit('regFormData2')">设置密码</Button>
            <div class="register">
              <p class="color_333 margin_auto">已有账号，去<span @click="type = 1">登录</span></p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Form, FormItem, Input, Card } from 'view-design'
import sha256 from 'js-sha256'
import { PhoneValid, PUValid, letterNumberAccount } from '@/utils/check'
import Fetch from '@/fetch/fly'
export default {
  components: {
    Button,
    Form,
    FormItem,
    Input,
    Card
  },
  data() {
    return {
      login_type: 2, //登录方式  1 手机号验证码登录  2 账号密码登录
      bg_img: '',
      bannerList: [],
      type: 1, // 1-登录 2-注册 3-找回密码
      imgCode: '', //图形验证码
      // 登录form
      loginFormData: {
        phone: '',
        password: '',
        kind: 1
      },
      // 注册/重置密码form
      regFormData: {
        phone: '',
        password: '',
        kind: 1,
        authCode: ''
      },
      sysInfo: {},
      // 登录验证
      loginRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: PhoneValid, message: '手机号格式错误', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, message: '密码格式错误', trigger: 'blur' }
        ]
      },
      // 注册验证
      regRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: PhoneValid, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, trigger: 'blur' }
        ],
        kind: [
          {
            required: true,
            type: 'number',
            message: '请选择身份',
            trigger: 'change'
          }
        ],
        authCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      // 登录form
      loginFormData2: {
        account: '',
        password: '',
        kind: 1
      },
      // 注册/重置密码form
      regFormData2: {
        account: '',
        password: '',
        confirm_password: '',
        kind: 1,
        captcha: ''
      },
      // 登录验证
      loginRules2: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { validator: letterNumberAccount, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, message: '密码格式错误', trigger: 'blur' }
        ]
      },
      // 注册验证
      regRules2: {
        account: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { validator: letterNumberAccount, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: PUValid, trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: PUValid, trigger: 'blur' }
        ],
        kind: [
          {
            required: true,
            type: 'number',
            message: '请选择身份',
            trigger: 'change'
          }
        ],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      handleBtnLoading: false, // 登录/注册按钮状态
      codeStatus: false, // false-可获取，true-获取中
      timeCount: 0 // 倒计时
    }
  },
  created() {
    this.getSysInfo()
  },
  methods: {
    async getSysInfo() {
      const params = {
        uriCode: 'API_PUB001'
      }
      const res = await Fetch(params)
      if (res.value) {
        const info = JSON.parse(decodeURI(res.value))
        this.sysInfo = info
        this.login_type = info.login_type ? info.login_type : 2
        if (info.favicon) {
          let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = info.favicon
          document.getElementsByTagName('head')[0].appendChild(link)
        }
        if (info.name) {
          document.getElementsByTagName('title')[0].innerHTML = info.name
        }
      }
    },
    // 获取图形验证码
    async getImgCode() {
      const params = {
        uriCode: 'API042'
      }
      const res = await this.$fetch(params)
      this.imgCode = res.captcha
    },
    // 获取验证码
    getCode() {
      this.$refs['regFormData'].validateField('phone', async valid => {
        if (!valid) {
          const params = {
            uriCode: 'API003',
            phone: this.regFormData.phone,
            kind: this.type === 2 ? 1 : 2
          }
          await this.$fetch(params)
          this.$msg.success('获取成功')
          this.codeStatus = true
          this.timeCount = 60
          this.countdown()
        } else {
          return
        }
      })
    },
    // 倒计时
    countdown() {
      let timer = null
      timer = setInterval(() => {
        if (this.codeStatus && this.timeCount > 1) {
          this.timeCount--
        } else {
          this.timeCount = 0
          this.codeStatus = false
          clearInterval(timer)
          timer = null
        }
      }, 1000)
      this.$once('hook:beforeDestroy', () => {
        clearInterval(timer)
        timer = null
      })
    },
    /**
     * 验证
     * name:表单名称
     */
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.type === 1) {
            this.login()
          } else if (this.type === 2) {
            this.signup()
          } else {
            this.signup()
          }
        }
      })
    },
    // 注册/重置密码
    async signup() {
      this.handleBtnLoading = true
      let params
      if (this.login_type === 1) {
        params = {
          uriCode: this.type === 2 ? 'API001' : 'API005',
          ...this.regFormData,
          password: sha256(this.regFormData.password)
        }
      } else {
        if (this.regFormData2.password !== this.regFormData2.confirm_password) {
          this.$msg.error('两次输入的密码不一致')
          this.handleBtnLoading = false
          return
        }
        params = {
          uriCode: this.type === 2 ? 'API001' : 'API005',
          account: this.regFormData2.account,
          kind: this.regFormData2.kind,
          captcha: this.regFormData2.captcha,
          password: sha256(this.regFormData2.password)
        }
      }

      try {
        await this.$fetch(params)
        this.$msg.success(`${this.type === 2 ? '注册' : '重置密码'}成功,正在登录`)
        // this.type = 1
        this.login_type === 1 ? this.login(this.regFormData) : this.login(this.regFormData2)
      } finally {
        this.handleBtnLoading = false
      }
    },
    // 登录
    async login(automatic) {
      this.handleBtnLoading = true
      // automatic存在就是自动登录
      const params =
        automatic && this.login_type === 1
          ? {
              uriCode: 'API002',
              kind: automatic.kind,
              phone: automatic.phone,
              password: sha256(automatic.password)
            }
          : automatic && this.login_type === 2
          ? {
              uriCode: 'API002',
              kind: automatic.kind,
              account: automatic.account,
              password: sha256(automatic.password)
            }
          : this.login_type === 1
          ? {
              uriCode: 'API002',
              ...this.loginFormData,
              password: sha256(this.loginFormData.password)
            }
          : {
              uriCode: 'API002',
              account: this.loginFormData2.account,
              kind: this.loginFormData2.kind,
              password: sha256(this.loginFormData2.password)
            }
      try {
        const res = await this.$fetch(params)
        localStorage.setItem('X-Token', res.token)
        this.$store.dispatch('getUserinfo')
        const routeName = sessionStorage.getItem('lastPath')
        const invite = sessionStorage.getItem('invite')
        // 如果是加入邀请的就回到邀请页面
        if (invite) {
          this.$router.push({
            name: 'invite',
            query: { ...JSON.parse(invite) }
          })
          return
        }
        this.$router.push({ name: routeName ? routeName : 'home' })
      } finally {
        this.handleBtnLoading = false
      }
    }
  },
  watch: {
    type() {
      if (this.login_type === 1) {
        this.$refs['loginFormData'].resetFields()
        this.$refs['regFormData'].resetFields()
      } else {
        this.$refs['loginFormData2'].resetFields()
        this.$refs['regFormData2'].resetFields()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.login-card {
  .title {
    font-size: 16px;
    color: #262626;
  }
}

.login_form2 {
}

.forgetpwd {
  float: right;
  margin-top: 4px;
  cursor: pointer;
  color: #468fef !important;
}

.todo {
  cursor: pointer;
}

.ipt-icon {
  width: 14px;
  height: 14px;
  margin-right: 7px;
  position: relative;
  bottom: 1px;
}

.bg {
  position: relative;
  min-width: 900px;
  min-height: 480px;
  // min-height: calc(100vh);
  background: url('~@/../public/images/login_bg.png') center no-repeat;
  background-size: auto;
  display: flex;
  align-items: center;
  height: 100vh;
  overflow-y: auto;
}

.bg_line {
  z-index: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 6px);
  background-size: auto;
  background: url('~@/../public/images/login_bg.png') center no-repeat;
  // height: 100vh;
}

.login_box {
  z-index: 99 !important;
  width: 900px;
  // min-height: 500px;
  // height: calc(100vh);
  position: relative;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .login {
    width: 900px;
    height: 478px;
    display: flex;

    // position: absolute;
    // top: 25%;
    .login_left {
      width: 420px;
      height: 478px;
      text-align: center;
      background: url('~@/../public/images/login_img.png') center no-repeat;
      box-sizing: border-box;
      padding-top: 150px;
      color: #fff;

      .logo {
        width: 60%;
        margin: 0 auto 80px;
        display: block;
        max-height: 50px;
      }

      dl {
        text-align: center;

        dt {
          margin-bottom: 15px;
        }

        img {
          width: 100px;
        }
      }
    }

    &-card {
      border-radius: 0%;
      width: 480px;
      height: 478px;
      margin: 0px auto;

      .card_form {
        box-sizing: border-box;
        padding: 0 60px;
        color: #4c4761;
      }
    }
  }
}

.btngroup {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);

  .login_btn {
    width: 197px !important;
    height: 36px !important;
    background-color: #468fef !important;
    margin: auto;
  }

  .register {
    width: 197px;
    height: 36px;
    margin-top: 20px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;

    button {
      width: 89px;
      height: 32px;
      border-radius: 2px;
      color: #468fef !important;
      border: 1px solid #468fef !important;
      margin-top: 4px;
      font-size: 14px;
    }

    button:hover {
      background-color: #468fef;
      color: #fff !important;
    }

    span {
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #015fff;
      text-align: center;
    }

    p {
      cursor: pointer;
      color: #a3a3a3;
    }

    p:hover {
      color: #666;
    }
  }
}

.color_333 {
  color: #333 !important;
}

.margin_auto {
  margin: auto !important;
}

.get_btn {
  width: 60px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  height: 32px !important;
  line-height: 32px !important;
}

.img-code {
  border: 1px solid #dcdee2;
  width: 100px;
  height: 32px;
  margin-left: 10px;
  cursor: pointer;
}

.flex {
  display: flex;
}
</style>
